module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"INVALID_VALUE":"Innholdet er ugyldig","MISSING_VALUE":"Dette feltet er obligatorisk"},"en":{"INVALID_VALUE":"Field value is not valid.","MISSING_VALUE":"Field cannot be empty."}}')
  delete Component.options._Ctor
}
